import {BECompetitionDetail} from 'API/types';
import {Sport} from './types';

export const sportNames: {sport: Sport; slug: string; name: string; eceSlug: string}[] = [
  {
    sport: Sport.SOCCER,
    slug: 'podosfairo',
    name: 'Ποδόσφαιρο',
    eceSlug: 'football',
  },
  {
    sport: Sport.BASKETBALL,
    slug: 'mpasket',
    name: 'Μπάσκετ',
    eceSlug: 'basket',
  },
  {
    sport: Sport.TENNIS,
    slug: 'tennis',
    name: 'Τένις',
    eceSlug: 'tennis',
  },
  {
    sport: Sport.VOLLEYBALL,
    slug: 'volei',
    name: 'Βόλεϊ',
    eceSlug: 'volley',
  },
  {
    sport: Sport.HANDBALL,
    slug: 'xantmpol',
    name: 'Χάντμπολ',
    eceSlug: 'handball',
  },
];

export const combineSportsAndCompetitionsItems = (
  competitions?: BECompetitionDetail[]
): {id: string; slug: string; name: string}[] => [
  ...sportNames.map(sn => ({id: sn.sport, slug: sn.slug, name: sn.name})),
  ...(competitions
    ? competitions.map(c => ({id: c.sportRadarId, slug: c.competitionSlug, name: c.name}))
    : []),
];

export const competitionsToSearchTerms = (
  competitions?: BECompetitionDetail[]
): {id: string; slug: string; name: string}[] =>
  (competitions || []).map(c => ({id: c.sportRadarId, slug: c.competitionSlug, name: c.name}));

export default {sportNames, combineSportsAndCompetitionsItems, competitionsToSearchTerms};
